import pino from 'pino';

export const logger = pino({
  level: process.env.LOG_LEVEL || 'info',
  base: null, // Remove default fields to avoid filesystem dependencies
  timestamp: false, // Simplify timestamp handling for serverless
  formatters: {
    level: (label) => ({ level: label }),
  },
});
